import * as React from "react";
// components
import { FormattedMessage } from "react-intl";
import CollectionItem from "./collectionItem";
import Icon from "common/icons";
import InfiniteScroll from "@vingle/wtf-sdk/components/infiniteScroller";
// styles

import PulseLoadingDot from "common/components/pulseLoadingDot";
const styles = require("./collections.scss");

interface IProps {
  collections: Vingle.IPaginatedList<Vingle.Collection.ICollection>;
  onLoadMore: () => void;
  redirectToCollectionShow: (collection: Vingle.Id) => void;
}

const FollowingCollection = ({
  collections,
  onLoadMore,
  redirectToCollectionShow,
}: IProps) => {
  const collectionItems = collections.data.map(
    (collection: Vingle.Collection.ICollection) => {
      return (
        <CollectionItem
          redirectToCollectionShow={redirectToCollectionShow}
          mine={false}
          key={`following_collection_${collection.id}`}
          collection={collection}
        />
      );
    },
  );

  const empty = (
    <div className={styles.emptyWrapper} key="following_collection_empty">
      <Icon icon="EMPTY_CARD" />
      <span className={styles.message}>
        <FormattedMessage id="profile.error_empty_following_collection" />
      </span>
    </div>
  );

  return (
    <div className={styles.itemWrapper}>
      <InfiniteScroll
        itemLength={collectionItems.length}
        threshold={300}
        loadMore={onLoadMore}
        paging={collections.paging}
        loader={
          <div
            className={styles.loaderWrapper}
            key="following_collection_loader"
          >
            <PulseLoadingDot />
          </div>
        }
      >
        {collectionItems.length > 0 ? collectionItems : empty}
      </InfiniteScroll>
    </div>
  );
};

export default FollowingCollection;
